import Rails from "@rails/ujs"
import Vue from 'vue'

$(document).ready(function(){
  // seller/inquiry/show
  // 問い合わせの対応状態を変更した時に即座に保存する
  $('[id^="select-"]').change(function() {
    Rails.fire($(this).parent()[0], 'submit')
  })

  $('.inquiry-info-card .mailer-trigger').on('click', event => {
    const el = event.target
    Vue.$modal.email({
      mailType: el.dataset.mailType,
      path: el.dataset.path,
      to: el.dataset.to,
      replyTo: el.dataset.replyTo,
      subject: el.dataset.subject,
      body: el.dataset.body,
      callback: () => {
        M.toast({ html: 'メールを送信しました' })
        $('.auto-replied-chip').remove()
        $('.manual-replied-chip').removeClass('hide')
      },
    })
  })
})
